import React, { useState } from 'react';
import useData from '../../hooks/useData';
import useToast from '../../hooks/useToast';
import AIAssistant from './AIAssistant';
import Checklist from './Checklist';
import InlineEditor from '../ui/InlineEditor';
import { ChevronDownIcon } from '../ui/Icons';
import CommentsWidget from './CommentsWidget';
import ActivityHistory from './ActivityHistory';

const TaskMainContent = ({ task, onDeleteCommentRequest }) => {
    const { handleUpdateTask } = useData();
    const { showToast } = useToast();
    
    // --- INÍCIO DA ALTERAÇÃO 1: Estado para controlar todas as seções, iniciando como fechadas ---
    const [openSections, setOpenSections] = useState({
        description: false,
        alterationChecklist: false,
        subtaskChecklist: false,
        comments: false,
        ai: false,
        history: false
    });

    const toggleSection = (section) => {
        setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
    };
    // --- FIM DA ALTERAÇÃO 1 ---

    const handleSaveDescription = (value) => {
        handleUpdateTask(task.id, { description: value }, 'alterou a descrição.');
        showToast('Descrição atualizada!');
    };

    // --- INÍCIO DA ALTERAÇÃO 2: Componente reutilizável para criar seções sanfonadas ---
    const CollapsibleSection = ({ title, sectionKey, children, contentPadding = "p-4 pt-0" }) => {
        const isOpen = openSections[sectionKey];
        return (
            <div className="bg-gray-200/50 dark:bg-white/5 rounded-lg">
                <button onClick={() => toggleSection(sectionKey)} className="w-full flex justify-between items-center p-4 text-left">
                    <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-300">{title}</h3>
                    <ChevronDownIcon size={20} className={`text-gray-500 dark:text-gray-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
                </button>
                {isOpen && (
                    <div className={`${contentPadding} animate-fade-in`}>
                        {children}
                    </div>
                )}
            </div>
        );
    };
    // --- FIM DA ALTERAÇÃO 2 ---

    return (
        <div className="lg:col-span-3 space-y-6">
            {/* --- INÍCIO DA ALTERAÇÃO 3: Aplicando a nova estrutura a todos os widgets --- */}
            <CollapsibleSection title="Descrição" sectionKey="description" contentPadding="px-4 pb-4">
                <InlineEditor title="Editar Descrição" value={task.description || ''} onSave={handleSaveDescription} editorType="textarea">
                    <div className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap min-h-[4rem] p-2 -m-2 rounded-md border-2 border-transparent hover:border-gray-300/50 dark:hover:border-white/20">
                        {task.description || "Clique para adicionar uma descrição..."}
                    </div>
                </InlineEditor>
            </CollapsibleSection>
            
            {task.isAlteration && (
                <div className="animate-fade-in">
                    <CollapsibleSection title="Checklist de Alteração" sectionKey="alterationChecklist">
                        <Checklist
                            task={task}
                            title="Checklist de Alteração"
                            field="alterationChecklist"
                            placeholder="Adicionar item da alteração..."
                            titleColor="text-orange-400"
                        />
                    </CollapsibleSection>
                </div>
            )}
            
            <CollapsibleSection title="Checklist de Sub-tarefas" sectionKey="subtaskChecklist">
                <Checklist 
                    task={task}
                    title="Checklist de Sub-tarefas"
                    field="subtasks"
                    placeholder="Adicionar sub-tarefa..."
                />
            </CollapsibleSection>
            
            <CollapsibleSection title="Comentários" sectionKey="comments">
                <CommentsWidget task={task} onDeleteRequest={onDeleteCommentRequest} />
            </CollapsibleSection>
            
            <CollapsibleSection title="Assistente IA" sectionKey="ai">
                <AIAssistant task={task} />
            </CollapsibleSection>

            <CollapsibleSection title="Histórico da Tarefa" sectionKey="history" contentPadding="px-2 pb-2">
                 <ActivityHistory task={task} />
            </CollapsibleSection>
            {/* --- FIM DA ALTERAÇÃO 3 --- */}
        </div>
    );
};

export default TaskMainContent;